<template>
  <div>
    <!-- <div style="padding-top:80px;"> -->
    <v-card height="500"  >
      <!-- <v-navigation-drawer permanent> -->
      

       
        <v-list dense nav>
          <v-list-item v-for="item in items" :key="item.title" link router-link :to="item.route" color="#ff4e00">
            <v-list-item-icon>
              <v-icon>{{ item.icon}}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
       
      <!-- </v-navigation-drawer> -->
    </v-card>
  </div>
</template>
<script>
import StarRating from "vue-star-rating";
import axios from "axios";
import AppSideNav from "@/components/common/AppSideNav";
// import Sellercomponent from "@/components/common/Sellercomponent";
export default {
  props: ["id"],
  components: {
    AppSideNav,
    StarRating
    // Sellercomponent
  },
  data() {
    return {
      data: [],
      right: null,
      items: [
        {
          title: "PRODUCTS",
          icon: "mdi-view-dashboard",
          route: "/ProductList"
        },
        { title: "PENDING PRODUCTS", icon: "mdi-image", route: "/Pending" },
        { title: "ADD PRODUCT", icon: "mdi-clipboard-plus", route: "/AddProduct" },
         { title: "PURCHASE DETAILS", icon: "mdi-checkerboard", route: "/SellerPurchase" }
      ],
      right: null,
      product: {
        name: null,
        price: null,
        desc: null,
        instock: null,
        seller: null,
        id: null,
        status: null
      }
    };
  },
  beforeMount() {
    this.getproducts();
  },
  methods: {
    getproducts() {
      axios({
        method: "GET",
        url: "/product/myproducts/",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      }).then(Response => {
        this.data = Response.data.data;
        this.photos = Response.data.data.photos;

        var tempflag = [];
        for (var i = 0; i < this.photos.length; i++) {
          var tyimg = {
            src: "https://api.inguzsales.in/u/" + this.photos[i],
            // src: $Image_URL + this.regions[i].flag,
            id: this.photos[i]
          };
          tempflag.push(tyimg);
        }
        this.dataImages = tempflag;
      });
    }
  }
};
</script>
<style scoped>
.prfont {
  font-family: "Montserrat";
}

</style>